module.exports = __webpack_public_path__ + "img/lt-box3.5177cd78.png";